import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
// `POST …/fields/{key}/verifications` carries no body: the field key travels in the URL alone.
class ConfirmDocumentField {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
		public readonly fieldKey: string,
	) {
		Object.freeze(this);
	}
}

export default ConfirmDocumentField;
